import React, { useEffect, useState, useRef } from 'react';
import AuthApiService, {
  UserPageAnnouncement,
} from '../../../usersite/services/AuthApiService';
import UserPageAnnouncementDialog from '../../../shared/components/UserPageAnnouncement/UserPageAnnouncementDialog';

const apiService = new AuthApiService();

interface AuthResponse {
  authenticated: boolean;
  isWorking: boolean;
  imageUrl: string | null;
  message: string | string[] | null;
  userPageAnnouncement?: UserPageAnnouncement;
}

// グローバルな状態で、一度だけ表示されるようにする
let isDialogInitialized = false;
let globalUserPageAnnouncement: UserPageAnnouncement | null = null;
let globalOpen = false;
let globalLoaded = false;

const AutoUserPageAnnouncementDialog = () => {
  const [open, setOpen] = useState(globalOpen);
  const [userPageAnnouncement, setUserPageAnnouncement] =
    useState<UserPageAnnouncement | null>(globalUserPageAnnouncement);
  const [loaded, setLoaded] = useState(globalLoaded);
  const hasInitialized = useRef(false);

  useEffect(() => {
    // 既に初期化済みの場合は何もしない
    if (hasInitialized.current || isDialogInitialized) {
      return;
    }

    hasInitialized.current = true;
    isDialogInitialized = true;

    // Auth APIを呼び出してuserPageAnnouncementの情報を取得
    apiService
      .fetchAuth()
      .then((response: AuthResponse) => {
        globalLoaded = true;
        setLoaded(true);
        if (
          response.authenticated &&
          response.userPageAnnouncement?.shouldShow
        ) {
          globalUserPageAnnouncement = response.userPageAnnouncement;
          globalOpen = true;
          setUserPageAnnouncement(response.userPageAnnouncement);
          setOpen(true);
        }
      })
      .catch(() => {
        globalLoaded = true;
        setLoaded(true);
      });
  }, []);

  const handleClose = () => {
    globalOpen = false;
    setOpen(false);
  };

  // 既に初期化済みで、他のインスタンスがデータを持っている場合はそれを使う
  useEffect(() => {
    if (isDialogInitialized && !hasInitialized.current) {
      if (globalLoaded && globalUserPageAnnouncement) {
        setLoaded(true);
        setUserPageAnnouncement(globalUserPageAnnouncement);
        setOpen(globalOpen);
      }
    }
  }, []);

  if (!loaded || !userPageAnnouncement) {
    return null;
  }

  return (
    <UserPageAnnouncementDialog
      open={open}
      hasExperienceReview={userPageAnnouncement.hasExperienceReview}
      onClose={handleClose}
    />
  );
};

export default AutoUserPageAnnouncementDialog;
